// extracted by mini-css-extract-plugin
export default {"warning-text":"DeleteFormModal_warning-text__ZTCpt","info-text":"DeleteFormModal_info-text__NSyys","button-container":"DeleteFormModal_button-container__Fe9PF"};